__turbopack_context__.v({
  "hidden": "course-seo-module-scss-module__re4Koa__hidden",
});
